import React from 'react';
import {Box} from '@mui/material';
import colors from 'shared/aptitude/colors';
import InfoIcon from 'shared/components/info-icon';
import FileUploadForm from 'src/components/FileUploadForm';
import Label from 'shared/components/label';
import FormikDropdown from 'src/components/formik-dropdown';
import Title from 'src/components/AccountSettings/Title';
import {EducationPhase} from 'src/types/enums';
import {TODAY} from 'shared/utils';
import useBrandName from 'src/hooks/use-brand-name';

const sampleCSVLink =
  'https://resources.raise.me/data/Data%20Submission%20Guidelines%20&%20Template%20-%20High%20School.xlsx';

const Disclaimer = () => {
  const brandName = useBrandName();
  return (
    <Box p={3} my={3} bgcolor={colors.m50} borderRadius="4px">
      <InfoIcon /> The provision of this data is a standard practice amongst all {brandName}{' '}
      colleges, is covered in terms of {brandName}’s partnership agreement, and is FERPA compliant
      per our Master Services Addendum.
    </Box>
  );
};

const TOTAL_YEAR_OPTIONS = 6;
const currentYear = TODAY.getFullYear();
const firstYearOption = currentYear - (TOTAL_YEAR_OPTIONS - 2);

const yearOptions = [...Array(TOTAL_YEAR_OPTIONS)]
  .map((_value, i) => `${firstYearOption + i}`)
  .map((option) => ({
    _id: option,
    value: option,
    text: option,
  }));

const educationPhaseOptions = [
  {
    _id: EducationPhase.HIGH_SCHOOL,
    value: EducationPhase.HIGH_SCHOOL,
    text: 'High School',
  },
  {
    _id: EducationPhase.COMMUNITY_COLLEGE,
    value: EducationPhase.COMMUNITY_COLLEGE,
    text: 'Transfer',
  },
];

const initialValues = {
  educationPhase: EducationPhase.HIGH_SCHOOL,
  year: String(currentYear),
};

const ManageDataSharing = (): React.ReactElement => {
  const brandName = useBrandName();
  return (
    <FileUploadForm
      fileDescription="Upload Full Inquiry or Applicant File"
      uploadType="ground_truth"
      Disclaimer={Disclaimer}
      initialOptionsValues={initialValues}
    >
      <Title>Manage Data Sharing</Title>
      <Box py={1}>
        Providing {brandName} with an inquiry or applicant file allows {brandName} to surface key
        insights on your results, conversion rates, and trends amongst your applicants and
        enrollments.
      </Box>
      <Box py={1}>
        Download a <a href={sampleCSVLink}>sample CSV template</a> to see an example of the
        requested format and required fields. Any questions? Email support@campuslogic.com.
      </Box>
      <div className="account-settings-form-section-side-by-side">
        <Label>
          File type
          <FormikDropdown
            options={educationPhaseOptions}
            name="educationPhase"
            testid="educationPhase"
          />
        </Label>
        <Label>
          Year
          <FormikDropdown options={yearOptions} name="year" />
        </Label>
      </div>
    </FileUploadForm>
  );
};

export default ManageDataSharing;
